import React from "react";
import { NavLink } from "react-router-dom";

interface NavLinkItemProps {
  to: string;
  icon: string;
  label: string;
}

const NavLinkItem = ({ to, icon, label }: NavLinkItemProps) => {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          isActive
            ? "bg-gradient-to-r from-[#4BBFED] to-[#008FC7] text-white py-3 px-6 rounded-lg flex items-center w-auto dark:text-white"
            : "hover:text-[#4BBFED] transition duration-300 py-3 px-6 rounded-lg flex items-center w-auto"
        }
      >
        <img src={icon} alt={`${label} Icon`} className="mr-3 h-6 w-6" />
        {label}
      </NavLink>
    </li>
  );
};

export default NavLinkItem;
